import { Button, Link, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { getAssetPath } from '@/constants/configs';
import { ROUTE } from '@/constants/routes';

import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

import {
  ButtonWrapper,
  Container,
  ContentWrapper,
  Logo,
} from './MinorTriggeredByAdult.styled';

export function MinorTriggeredByAdult() {
  const { t } = useTranslate();
  const navigate = useNavigate();
  const { adultName } = useLocation().state;

  const onBackToLogin = () => {
    navigate(ROUTE.HOME);
  };

  if (!adultName) {
    onBackToLogin();
  }

  const message = (
    <Trans
      i18nKey="createNewAccount.triggeredByAdult.message"
      values={{ adultName }}
      components={{
        PhoneLink: (
          <Link color="primary" fontWeight="bold" href="tel:345-949-8300" />
        ),
      }}
    />
  );

  return (
    <Container {...getDataTestId('minor-triggered-by-adult-screen')}>
      <Logo
        src={getAssetPath('/logo-with-text.svg')}
        alt="Republic Bank"
        {...getDataTestId('minor-triggered-by-adult-logo')}
      />

      <ContentWrapper>
        <Typography
          variant="h4"
          mb={3}
          {...getDataTestId('minor-triggered-by-adult-title')}
        >
          {t('createNewAccount.triggeredByAdult.header')}
        </Typography>

        <Typography
          variant="body2"
          mb={3}
          {...getDataTestId('minor-triggered-by-adult-body')}
        >
          {message}
        </Typography>

        <ButtonWrapper>
          <Button
            fullWidth
            variant="text"
            onClick={onBackToLogin}
            {...getDataTestId('minor-triggered-by-adult-login-button')}
          >
            {t('createNewAccount.triggeredByAdult.button.backToLogin')}
          </Button>
        </ButtonWrapper>
      </ContentWrapper>
    </Container>
  );
}

export default MinorTriggeredByAdult;
